import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateTimeFormat'
})
export class DateTimeFormatPipe implements PipeTransform {

    transform(value: any): any {
        let parsedDate =  moment(value);
        if (parsedDate.isValid()) {
            return moment(value).format('DD/MM/YYYY HH:mm:ss');
        } else {
            return ''
        }
    }

}
